/**
 * 日志上报相关接口
 */

import { post, ApiResponse } from './api';
import { API_PATHS } from './apiPaths';

/**
 * 上传错误日志
 */
export async function uploadLog(body?: any, params?: any): Promise<ApiResponse<any>> {
  return post(API_PATHS.UploadLog, body, { params, originReturn: true });
}
